module.exports = __webpack_public_path__ + "static/media/session_cookie.b4361e3d.svg";